import { Grid, TextField, MaskedInput } from "../../../../components";

const FormFiltroAvancado = ({ valueInput, onChangeInput }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <MaskedInput
          id="placa"
          name="placa"
          label="Placa"
          type="text"
          fullWidth
          mask="aaa-9*99"
          onChange={(event) => onChangeInput(event)}
          value={valueInput("placa")}
          required
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          id="renavam"
          name="renavam"
          label="Renavam"
          fullWidth
          variant="outlined"
          onChange={(event) => onChangeInput(event)}
          value={valueInput("renavam")}
        />
      </Grid>
    </Grid>
  );
};

export default FormFiltroAvancado;
